export function shuffleArray(array) {
  let currentIndex = array.length;
  let temporaryValue, randomIndex;

  // 配列にまだ未処理の要素がある限り、続ける
  while (currentIndex !== 0) {
    // 残りの要素からランダムなインデックスを選択
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // 現在の要素とランダムに選択された要素を交換
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}